import { Card, CardContent } from "@/components/ui/card"
import { VALIDATION_ERROR_KEYS } from "@/i18n"
import { DataDrivenFormSchema } from "@/lib/data-driven-forms/schema"
import { useTranslation } from "react-i18next"
import * as z from "zod"
import logo from "/images/Full Logotype.svg"
import { FormRenderer } from "@/lib/data-driven-forms/renderer"
import { useId } from "react"
import { Button } from "@/components/ui/button"
import Flash from "@/components/ui/flash"
import { useNavigate } from "@/lib/page-rendering"

const formSchema: DataDrivenFormSchema<"users"> = {
  type: "form",
  validator: z.object({
    email: z.email(VALIDATION_ERROR_KEYS.MUST_BE_VALID_EMAIL).trim(),
  }),
  namespace: "users",
  properties: [
    {
      type: "field:input",
      name: "email",
      label: "form.forgot_password.email",
      inputType: "email",
    },
  ],
}

export default function Page() {
  const navigate = useNavigate()
  const { t } = useTranslation("users", { keyPrefix: "form.forgot_password" })
  const formId = useId()
  return (
    <>
      <Card className="m-8 max-w-md min-w-96 self-center p-8">
        <CardContent>
          <div className="mb-8 flex flex-row items-center justify-center">
            <img src={logo} alt="Sagecool Logo" className="h-22.5" />
          </div>
          <Flash />

          <FormRenderer
            formId={formId}
            schema={formSchema}
            defaultValues={{}}
            onSubmit={(data) =>
              navigate({
                href: "/users/password",
                method: "post",
                data: { user: data },
              })
            }
          />
          <Button form={formId} className="mt-4 w-full">
            {t("action")}
          </Button>
        </CardContent>
      </Card>
    </>
  )
}
